<template>
  <nav class="border-b-4 border-indigo-500 px-2 sm:px-4 py-2.5 rounded dark:bg-inherit">
    <div class="container flex flex-wrap justify-between items-center mx-auto">
      <a href="#" class="flex items-center">
        <span class="text-xl font-semibold dark:text-gray-100">
          <svg id="Brand" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
          </svg>
        </span>
        <span class="Brand self-center text-xl font-semibold whitespace-nowrap dark:text-white mx-1"><span class="text-indigo-500">{</span> RG <span class="text-indigo-500">}</span></span>
      </a>
      <div class="border-b dark:border-gray-700">
        <ul class="flex flex-wrap -mb-px text-sm font-medium text-center dark:text-gray-400" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
          <li class="mr-2">
            <button class="HomeBtn cursor-link inline-flex p-4 rounded-t-lg border-b-2 dark:border-indigo-500 hover:border-gray-300 dark:hover:text-gray-300 group" id="profile-tab" data-tabs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="true">
              <svg class="mr-2 w-5 h-5 text-indigo-500 dark:text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>Home
            </button>
          </li>
          <li class="mr-2">
            <button class="cursor-link inline-flex p-4 rounded-t-lg border-b-2 dark:border-indigo-500 hover:border-gray-300 dark:hover:text-gray-300 group" id="settings-tab" data-tabs-target="#CV" type="button" role="tab" aria-controls="CV" aria-selected="false">
              <svg class="mr-2 w-5 h-5 text-indigo-500 dark:text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"></path></svg>CV
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Nav"
}
</script>

<style scoped>
[aria-selected="true"] {
  border-bottom: #6465f1 1px solid !important;
  color: #6366f1 !important;
}

[aria-selected="false"] {
  border-bottom: none !important;
  width: auto;
}
</style>